export function asideobserver(): void {
	const options = {
		root: null,
		rootMargin: "600px",
		threshold: 0.7,
	};

	const asideSticky = document.querySelector("#aside-sticky");

	const callback = function (entries: any[]) {
		let observed = entries[0];

		if (asideSticky) {
			if (observed.isIntersecting) {
				asideSticky.classList.add("hidden-observed");
			}
			else {
				asideSticky.classList.remove("hidden-observed");
			}
		}
	};
	var navbar = document.querySelector(".al-navbar-default");
	if (navbar) {
		const observer = new IntersectionObserver(callback, options);
		observer.observe(navbar);
	}
};